import { render, staticRenderFns } from "./SubGroupSelectionTreeItem.vue?vue&type=template&id=2d08b6fa"
import script from "./SubGroupSelectionTreeItem.vue?vue&type=script&lang=ts"
export * from "./SubGroupSelectionTreeItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports